
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import { moneyFormat } from "@/utils/util";
import { getReportTransaction, getReportTransactionTotal } from "@/api/shouyin";

// 交易明细
@Component({
  components: {
    CardContainer,
  },
})
export class TransactionDetails extends Vue {
  @Prop({ default: () => ({}) }) params!: any;

  isInit = false;
  moneyFormat = moneyFormat;
  grid = [
    {
      label: "销售金额",
      value: 0,
      prop: "totalOrderMoney",
      isMoney: true,
    },
    {
      label: "销售笔数",
      value: 0,
      prop: "totalOrderCount",
      isMoney: false,
    },
  ];
  listData = [];
  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  getData() {
    this.isInit = false;
    Promise.all([
      getReportTransaction({ ...this.params, pageIndex: 1, pageSize: 3 }),
      getReportTransactionTotal(this.params),
    ]).then((res) => {
      const [transactionRes, totalRes] = res;
      this.listData = transactionRes.data.records || [];
      this.grid.forEach((item) => {
        item.value = totalRes.data[item.prop];
      });
      this.isInit = true;
    });
  }
}
export default TransactionDetails;
